export default {
  '请求': {
    '加载中': '로딩 중',
    '请求失败': '요청 실패',
    '登录已过期': '로그인이 만료되었습니다',
    '网络连接失败': '네트워크 연결 실패',
    '请重新登录': '다시 로그인해 주세요',
    '没有权限访问': '접근 권한이 없습니다',
    '请求的资源不存在': '요청한 리소스가 없습니다',
    '服务器错误': '서버 오류',
    '网络错误': '네트워크 오류',
    '刷新成功': '새로고침 완료',
    '获取中': '불러오는 중......',
    '账号下线': '계정 오프라인',
    '功能已禁用': '기능이 비활성화되었습니다',
  },
  '导航': {
    '首页': '홈',
    '选妃': '선택',
    '认证': '인증',
    '影院': '영상',
    '个人': '마이',
  },
  '首页': {
    '注册': '회원가입',
    '影片': '영상',
    '女团': '걸스',
    '热门城市': '인기 도시：',
    '经理预订': '매니저 예약',
    '看更多': '더 보기',
    '身份验证': '인증됨',
    '身高': '키',
    '胸围': '가슴',
    '服务城市': '서비스 도시：',
  },
  '女团': {
    '女团': '걸스',
    '选妃': '선택',
    '身份验证': '인증됨',
    '身高': '키',
    '胸围': '가슴',
    '服务城市': '서비스 도시:',
    '注册': '회원가입',
    '请联系顾问或接待员': '상담원 또는 안내원에게 문의해 주세요',
  },
  '登录': {
    '登录会员视窗': '회원 로그인',
    '请输入用户名': '아이디를 입력하세요',
    '请输入密码': '비밀번호를 입력하세요',
    '登录': '로그인',
    '没有账号马上注册': '계정이 없으신가요? 바로 가입',
    '登录成功': '로그인 성공',
    '登录注册': '로그인 / 회원가입',
    '登录可享受更多服务': '로그인하면 더 많은 서비스를 이용할 수 있습니다!',
  },
  '注册': {
    '注册': '회원가입',
    '登录': '로그인',
    '请输入用户名': '아이디를 입력하세요',
    '用户名规则': '영문·숫자 6~20자',
    '请输入密码': '비밀번호를 입력하세요',
    '密码规则': '문자·숫자 조합 6~16자',
    '请输入验证码': '인증코드를 입력하세요',
    '验证码规则': '영숫자 4자리 인증코드를 입력하세요',
    '请输入邀请码': '초대코드를 입력하세요',
    '邀请码规则': '대리점 초대코드를 입력하세요',
    '同意协议': '만 18세 이상이며 《가입 약관》에 동의합니다',
    '立即注册': '지금 가입',
    '注册中': '가입 중...',
    '已有账号马上登录': '이미 계정이 있으신가요? 로그인',
    '注册成功': '가입 완료!',
    '注册失败': '가입 실패：',
    '验证码错误': '인증코드가 올바르지 않습니다',
    '请同意注册条款': '가입 약관에 동의해 주세요',
    '用户名已存在': '이미 사용 중인 아이디입니다',
    '邀请码无效': '유효하지 않은 초대코드입니다',
  },
  '抢单': {
    '今日收益': '오늘의 수익',
    '余额': '잔액',
    '订单': '주문',
    '开始抢单': '주문 받기 시작',
    '当前等级': '현재 등급：',
    '提现': '출금',
    '在线客服': '온라인 고객센터',
    '充值': '충전',
    '幸运任务': '행운 미션',
    '幸运订单': '행운 주문',
    '幸运订单提示': '축하합니다! 고수수료 행운 주문입니다',
    '恭喜获得幸运订单': '행운 주문을 받았습니다!',
    '提交订单': '주문 제출',
    '未完成订单提示': '미완료 주문이 있습니다. 결제 후 새 주문을 받아 주세요',
    '正在获取订单': '주문을 불러오는 중...',
    '抢单时间': '주문 시간：',
    '订单号': '주문번호',
    '订单总额': '주문 총액',
    '佣金': '수수료',
    '商品单价': '상품 단가',
    '预计收入': '예상 수익',
    '确认支付': '결제 확인',
    '确认付款': '결제 확정',
    '支付处理中': '결제 처리 중...',
    '取消': '취소',
    '去查看': '확인하기',
    '暂无可用订单': '이용 가능한 주문이 없습니다',
    '正在加载用户信息': '회원 정보를 불러오는 중...',
    '今日抢单已达上限': '오늘 주문 한도에 도달했습니다',
    '余额不足无法获取订单': '잔액이 부족하여 주문을 받을 수 없습니다',
    '获取订单失败': '주문 불러오기 실패',
    '支付成功': '결제 성공',
    '支付失败': '결제 실패',
    '支付失败请重试': '결제에 실패했습니다. 다시 시도해 주세요',
    '请完成任务单后进入': '미션을 완료한 후 입장해 주세요',
    '请设置收款卡': '수취 계좌를 설정해 주세요',
  },
  '我的': {
    '我的页面': '마이페이지',
    '钻石': '다이아몬드',
    '信誉分': '신용점수',
    '开通专属会员': '전용 회원 개통',
    '开启一次日期不限': '한 번 개통하면 날짜 제한 없음',
    '提现': '출금',
    '历史订单': '주문 내역',
    '充值记录': '충전 내역',
    '提现记录': '출금 내역',
    '添加钱包地址': '지갑 주소 추가',
    '邀请码': '초대코드：',
    '余额': '잔액',
    '退出登陆': '로그아웃',
  },
  '会员': {
    '会员等级': '회원 등급：',
    '普通等级': '일반 등급',
    '当前等级': '현재 등급',
    '立即开通': '지금 개통',
    '免费说明': '(무료 영상 시청) (무료 매칭)',
    '所需投资': '필요 투자',
    '佣金': '수수료',
    '订单': '주문',
    '加入': '가입 >>',
  },
  '充值': {
    '充值': '충전',
    '当前余额': '현재 잔액',
    '余额': '잔액：',
    '个': '',
    '充值金额': '충전 금액',
    '请输入充值金额': '충전 금액을 입력하세요',
    '快速选择金额': '빠른 금액 선택',
    '确认': '확인',
    '提示': '안내',
    '金额错误': '금액 오류',
    '立即充值': '지금 충전',
    '提交成功': '제출 완료, 심사를 기다려 주세요',
  },
  '提现': {
    '提现': '출금',
    '兑换积分': '포인트 환전',
    '最大提款金额': '최대 출금 금액',
    '资金密码': '자금 비밀번호',
    '余额': '잔액：',
    '个': '',
    '钱包地址': '지갑 주소：',
    '请选择提款地址': '출금 주소를 선택하세요',
    '暂无绑定地址': '등록된 주소가 없습니다. 먼저 등록해 주세요',
    '提交': '제출',
    '通知': '안내：',
    '单笔最大提现': '1、1회 최대 출금 금액:',
    '单笔最低提现': '2、1회 최소 출금 한도：',
    '检查姓名账号': '3、성명과 출금 계좌를 확인해 주세요',
    '注意提款费用': '4、출금 수수료에 유의하세요',
    '请填写正确的金额': '올바른 금액을 입력해 주세요',
    '当前余额': '현재 잔액',
    '提现金额': '출금 금액',
    '请输入提现数量': '출금 수량을 입력하세요',
    '立即提现': '지금 출금',
    '交易密码': '거래 비밀번호',
    '请输入交易密码': '거래 비밀번호를 입력하세요',
    '请先设置提现密码': '먼저 출금 비밀번호를 설정해 주세요',
  },
  '绑卡': {
    '添加钱包地址': '지갑 주소 추가',
    '钱包地址信息': '지갑 주소 정보',
    '请输入支付卡信息': '지갑 주소 정보를 입력하세요',
    '加密货币类型': '암호화폐 유형',
    '请选择加密货币类型': '암호화폐 유형을 선택하세요',
    '钱包地址': '지갑 주소',
    '请输入钱包地址': '지갑 주소를 입력하세요',
    '绑卡说明': '고객님의 자금 안전을 위해 실명을 등록하고 출금 비밀번호를 설정해 주세요. 성명이 계좌 명의와 일치하지 않으면 출금할 수 없습니다.',
    '确定绑卡': '카드 등록 확인',
    '绑卡提示': '안내: 대형 시중은행에 등록하세요. 변경이 필요하면 온라인 고객센터에 문의해 주세요',
    '请先设置姓名': '성명을 설정한 후 지갑 주소를 등록해 주세요!',
    '已绑定不可修改': '출금 주소가 이미 등록되었습니다. 변경은 고객센터에 문의하세요',
  },
  '订单历史': {
    '订单历史': '주문 내역',
    '数据为空': '데이터 없음',
    '订单号': '주문번호：',
    '已完成': '완료',
    '处理中': '처리 중',
    '完成订单': '주문 완료',
    '订单金额': '주문 금액：',
    '佣金': '수수료：',
    '创建时间': '생성 시간：',
    '上一页': '이전',
    '下一页': '다음',
    '获取失败': '주문 내역 불러오기 실패',
    '获取失败重试': '주문 내역 불러오기 실패, 다시 시도해 주세요',
    '未知': '알 수 없음',
    '完成成功': '주문이 완료되었습니다!',
    '完成失败': '주문 완료 실패：',
    '完成失败重试': '주문 완료 실패, 다시 시도해 주세요',
    '请输入支付密码': '결제 비밀번호를 입력하세요',
    '请先设置支付密码': '먼저 결제 비밀번호를 설정하세요',
  },
  '入金记录': {
    '标题': '충전 내역',
    '数据为空': '데이터 없음',
    '认证结果': '심사 결과',
    '下单积分': '주문 포인트：',
    '下单时间': '주문 시간：',
    '结算时间': '정산 시간：',
    '待审核': '심사 대기',
    '已通过': '승인됨',
    '已拒绝': '거절됨',
    '暂无数据': '데이터 없음',
  },
  '提现记录': {
    '标题': '출금 내역',
    '数据为空': '데이터 없음',
    '待审核': '심사 대기',
    '审核成功': '심사 통과',
    '审核退回': '심사 반려',
    '未知状态': '알 수 없는 상태',
    '金额': '금액：',
    '说明': '설명：',
    '提交时间': '제출 시간：',
    '审核时间': '심사 시간：',
    '已通过': '승인됨',
    '已拒绝': '거절됨',
    '暂无数据': '데이터 없음',
  },
  '资料': {
    '基本信息': '기본 정보',
    '头像': '프로필 사진',
    '姓名': '성명',
    '未设置': '미설정',
    '性别': '성별',
    '男': '남',
    '女': '여',
    '未知': '알 수 없음',
    '设定': '설정',
    '账号信息': '계정 정보',
    '更改登录密码': '로그인 비밀번호 변경',
    '设定支付密码': '결제 비밀번호 설정',
    '退出登录': '로그아웃',
    '设置': '설정',
    '登录密码': '로그인 비밀번호',
    '资金密码': '자금 비밀번호',
    '提现密码已设置': '출금 비밀번호가 설정되었습니다. 변경은 고객센터에 문의하세요',
    '已设置': '설정됨',
    '修改真实姓名': '실명 수정',
    '请输入真实姓名': '실명을 입력하세요',
    '真实姓名说明': '계정 안전을 위해 실명은 지갑 정보와 일치해야 합니다',
    '提交': '제출',
    '请勿重复设置': '중복 설정하지 마세요!',
    '修改登录密码': '로그인 비밀번호 변경',
    '设置资金密码': '자금 비밀번호 설정',
    '保存': '저장',
    '旧密码': '기존 비밀번호',
    '请输入旧密码': '기존 비밀번호를 입력하세요',
    '新密码': '새 비밀번호',
    '请输入新密码': '새 비밀번호를 입력하세요',
    '确认密码': '비밀번호 확인',
    '请再次输入新密码': '새 비밀번호를 다시 입력하세요',
    '请填写完整': '모든 항목을 입력해 주세요!',
    '两次密码不一致': '비밀번호가 일치하지 않습니다',
    '性别修改': '성별 변경',
    '个人报表': '개인 리포트',
    '任务金额积分': '미션 금액(포인트)',
    '盈利公式': '수익 계산식 : 당첨 금액 - 미션 금액',
    '任务金额': '미션 금액',
    '充值金额': '충전 금액',
    '金额': '금액',
    '中奖金额': '당첨 금액',
    '个人情报': '개인 정보',
    '身高': '키:',
    '胸围': '가슴：',
    '收费区间': '요금 구간：',
    '系统公告': '시스템 공지',
  },
  '客服': {
    '联系客服': '고객센터 문의',
    '在线客服': '온라인 고객센터',
    '暂无客服': '이용 가능한 고객센터가 없습니다',
    '联系': '문의',
    '服务时间': '연중무휴 24시간 최선을 다해 모시겠습니다',
  },
  '影院': {
    '影院': '시네마',
    '全部': '전체',
    '最高分': '최고 평점',
    '播放': '재생 :',
    '次播放': '회 재생',
    '热门推荐': '인기 추천',
    '播放次数': '재생:',
    '请充值后观看': '충전 후 영상을 시청해 주세요',
  },
  '语言切换器': {
    '切换语言': '언어 전환',
    '语言': '언어',
  },
}
